import React, { useEffect, useState } from 'react'
import { Line } from 'react-chartjs-2'
import { ColumnChartWrapper } from '../dashboard.styled'
import { DashboardSources, DefaultColor } from '../../../constants/DashboardConf'
import ChartHeader from './ChartHeader'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import ChartDatePicker from './ChartDatePicker'
import dayjs from 'dayjs'

function LineChart (props) {
  const { data: d, settingMode, useFakeData } = props
  const { UISetting, tableName, categoryDetail, content } = d || {}
  const { title, xAxis, limit, style, dateFilter } = UISetting || {}
  const [data, setData] = useState([])
  const [multipleTitle, setMultipleTitle] = useState([])
  const theme = Object.values(style?.themeColor || {})
  const colorTheme = theme?.length ? theme : DefaultColor

  const chartOptions = {
    plugins: { datalabels: { display: false } },
    legend: { display: false },
    interaction: { mode: 'index', intersect: true },
    tooltips: { mode: 'x-axis', intersect: true, displayColors: false },
    scales: { y: { stacked: true } }
  }

  const defaultConf = {
    fill: false,
    tension: 0
  }
  const chartData = {
    labels: data?.map(i => i.label),
    datasets: multipleTitle?.length
      ? multipleTitle?.map((title, idx) => ({
        label: title,
        data: data?.map(i => Number(i[title])),
        borderColor: colorTheme[idx + 1],
        ...defaultConf
      }))
      : [{
          label: title,
          data: data?.map(i => Number(i.value)),
          borderColor: colorTheme?.[1],
          ...defaultConf
        }]
  }

  const useFake = useFakeData && categoryDetail === DashboardSources.THIRD_PARTY
  const handleDateFilterChange = ([start, end]) => {
    if (settingMode || useFake) return
    const filteredData = content?.data?.filter(i => {
      const dataDate = dayjs(i.label).isValid() ? dayjs(i.label) : false
      if (!dataDate) return false
      return dayjs(start) < dataDate && dataDate < dayjs(end)
    })
    setData(filteredData)
  }

  useEffect(() => {
    if (!settingMode && !useFake && !content?.data) return
    const fakeData = Array.from({ length: limit || 5 }, () => Math.floor(Math.random() * (limit || 5))).reverse().map((i, idx) => ({ label: `${xAxis || tableName || categoryDetail} ${idx + 1}`, value: i }))
    if (settingMode || useFake) return setData(fakeData)
    const titles = Object.keys(content?.data?.[0] || [])?.filter(i => i !== 'label' && i !== 'value')
    setMultipleTitle(titles)
    if (!dateFilter) setData(content?.data)
  }, [content])

  return (
    <>
      <ChartHeader {...props} />
      {dateFilter && <ChartDatePicker isMonth={xAxis === 'm'} handleChange={handleDateFilterChange} content={content} />}
      <ColumnChartWrapper>
        <Line options={chartOptions} data={chartData} height={120} plugins={[ChartDataLabels]} />
      </ColumnChartWrapper>
    </>
  )
}

export default LineChart
